export enum ChatkeeperRequestTypeEnum {
  SendMessage = 'SendMessage',
  ChangeReputation = 'ChangeReputation',
  ChangePoints = 'ChangePoints',
  ChangeAchievements = 'ChangeAchievements',
  RunTrigger = 'RunTrigger',
  CompleteCaptcha = 'CompleteCaptcha',
}
